import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

/*Sales Form for Caravan and Mobile Home is apparently called Trade Type*/
export const TradeType = ({ tradeType }: SpecProps<"trade_type">) => {
  const { i18n } = useLingui();

  if (!tradeType) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.sales_form",
    message: "Sales form",
    comment: "Field for 'sales form' in ad specification",
  });

  switch (tradeType.id) {
    case 1:
      return (
        <FieldValuePair
          field={field}
          value={i18n.t({
            id: "itemPageLayout.keyInfo.tradeType.forSale",
            message: "For sale",
            comment: "Field for 'trade type' in ad specification",
          })}
        />
      );
    case 2:
      return (
        <FieldValuePair
          field={field}
          value={i18n.t({
            id: "itemPageLayout.keyInfo.tradeType.forRent",
            message: "For rent",
            comment: "Field for 'trade type' in ad specification",
          })}
        />
      );
    default:
      return <FieldValuePair field={field} value={tradeType} />;
  }
};
